import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link, Navigate, useParams } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import projects from "../data/projects";

const ProjectDetailPage = () => {
  const { projectSlug } = useParams();
  const project = projects.find(({ slug }) => slug === projectSlug);

  if (!project) return <Navigate to="/projects" replace />;

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main className="pt-16">
        <section className="min-h-[calc(100vh-4rem)] flex items-center py-20">
          <div className="max-w-7xl mx-auto px-6 w-full">
            <Link to="/projects" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-700 hover:text-brand-600 mb-10">
              <ArrowLeft size={16} /> Back to projects
            </Link>
            <div className="max-w-3xl">
              <p className="text-xs font-semibold tracking-widest text-brand-600 uppercase mb-4">Project</p>
              <h1 className="font-display text-5xl md:text-6xl font-bold tracking-tight text-ink leading-[1.05]">
                {project.title}
              </h1>
              <div className="mt-8 border-l-2 border-brand-500 pl-6">
                <p className="text-xl text-ink-muted leading-relaxed">
                  This case study is being prepared. Project context, approach, findings, and outcomes will be added here.
                </p>
              </div>
              <span className="inline-flex mt-10 px-3 py-1 rounded-full border border-paper-300 bg-paper-100 text-xs font-semibold tracking-wide text-ink-muted uppercase">
                Coming soon
              </span>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ProjectDetailPage;
